export const jagodaGajewska = {
    'mydrId': 'jagodagajewska',
    'firstName': 'Jagoda',
    'lastName': 'Gajewska',
    'profession': 'Psycholog, Psychoterapeuta behawioralno-poznawczy',
    'avatar': 'jagoda-gajewska.webp',
    'slug': 'psychoterapeuta-jagoda-gajewska',
    'locations': ['torun'],
    'services': [
        ['group', 'preventionGroup'],
        ['psychoterapy', 'children'],
        ['psychology', 'consultation']
    ]
}